import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { OnDestroy } from '@angular/core';

import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { NotificationService } from '../../../../services/notification.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { Subject } from 'rxjs';
@Component({
  selector: 'app-contract-details',
  standalone: true,
  imports: [CommonModule, TranslateModule, HttpClientModule],
  providers: [Base64UrlService],
  templateUrl: './contract-details.component.html',
  styleUrl: './contract-details.component.css'
})
export class ContractDetailsComponent implements AfterViewInit{
  userName: any;
  lang: any;
  jobOrderId: any;
  detailsData: any;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private route: ActivatedRoute, private auth: AuthService,private translate: TranslateService, private ns: NotificationService, private pageTitle: PageTitleService, private en: EncryptionService, private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { 
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') { 

      this.lang = (localStorage.getItem('site_lang')?localStorage.getItem('site_lang'): 'en');
      console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
    this.userName = this.auth.getName();
    this.pageTitle.setTitle('menu.timesheet');
    this.jobOrderId = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['id']));
    this.getDetails();
  }
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => { });
        }
}
  getDetails() {
    this.ns.getContractDetails(this.jobOrderId)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            console.log(res.data);
            this.detailsData = res.data;
          }
        },
        error: (err: any) => {
          console.log(err)
          if (err.status == 401) {
            this.auth.logout();
			return
          }
        }
    })
  }
ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {}
  }



}
